/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarEventResponse } from '../../models/calendar-event-response';
import { EventCreateRequest } from '../../models/event-create-request';

export interface PostFeV1Events$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
  
    /**
     * Event creation data.
     */
    body?: EventCreateRequest
}

export function postFeV1Events$Plain(http: HttpClient, rootUrl: string, params?: PostFeV1Events$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventResponse>> {
  const rb = new RequestBuilder(rootUrl, postFeV1Events$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendarEventResponse>;
    })
  );
}

postFeV1Events$Plain.PATH = '/v1/events';
